"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'c_tag_list',
  props: {
    configObj: {
      type: Object
    },
    configNme: {
      type: String
    }
  },
  components: {
    draggable: _vuedraggable.default
  },
  data: function data() {
    return {
      defaults: {},
      configData: {}
    };
  },
  computed: {
    maxList: function maxList() {
      return this.configData.maxList || 4;
    }
  },
  created: function created() {
    this.defaults = this.configObj;
    this.configData = this.configObj[this.configNme];
  },
  watch: {
    configObj: {
      handler: function handler(nVal) {
        this.configData = nVal[this.configNme];
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 上传标签图片
    modalPicTap: function modalPicTap(item) {
      this.$modalUpload(function (img) {
        if (!img) return;
        item.img = img[0].sattDir;
      });
    },
    addTag: function addTag() {
      this.configData.list.push({
        img: '',
        val: ''
      });
    },
    bindDelete: function bindDelete(index) {
      this.configData.list.splice(index, 1);
    }
  }
};